import { IconBranch } from '@components/icons/branch';
import { Sidebar } from '@components/sidebar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useNodes } from 'ui/journey-builder/hooks/use-nodes';
import {
  ActionDuplicateButton,
  ActionHeader,
  ActionRemoveButton,
  SidebarProps,
} from 'ui/journey-builder/node-types/common';

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);
  const { getNode } = useNodes();
  const { isRemoveDisabled } = getNode(journeyActionId)?.data ?? {};

  return (
    <Sidebar>
      <ActionHeader title={t('branch')} icon={IconBranch} iconColor="teal100" {...props} />
      <Sidebar.Content>
        <Stack space={4}>
          <Text font="regular14">
            {t('description')}{' '}
            <a
              href="https://help.journeys.50skills.app/en/articles/236531-branch-collapse-and-labels"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline', color: 'inherit' }}
            >
              {t('readMore')}
            </a>
          </Text>
        </Stack>
      </Sidebar.Content>
      <Sidebar.Footer>
        <Stack space={2} orientation="horizontal">
          <ActionRemoveButton
            action={{ action: 'journey_branch', shortId: journeyActionId }}
            disabled={isRemoveDisabled}
            tooltip={isRemoveDisabled ? t('cantRemove') : undefined}
          />
          <ActionDuplicateButton journeyActionShortId={journeyActionId} />
        </Stack>
      </Sidebar.Footer>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    branch: 'Branch',
    cantRemove: "You can't remove a branch action that has multiple dependants",
    description:
      'Use branches when you want to run multiple actions at the same time.\n\n' +
      'When creating a branch action, each branch will get its own label which is anchored at the top. ' +
      'This label can be renamed to what you feel like fits the best for the purpose of the branch.\n\n' +
      'You can now collapse either a single branch or the entire tree so you can focus only on what is important. \n\n' +
      'Read a more detailed explanation in our help section',
    readMore: '\nRead more',
  },
};
